// https://vuex.vuejs.org/en/getters.html

export default {
    getVendorNameById: state => vendorId => {
        var vendor = state.list.find(v => v.uid === vendorId)
        return vendor ? vendor.name : ''
    },
    getVendorNameByProduct: state => product => {
        if (!product) {
            return null
        }
        var vendor = state.list.find(v => v.uid === product.vendorId)
        return vendor ? vendor.name : ''
    },
}
